import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import MyInput from 'components/controls/MyInput';
import DropdownList from 'components/controls/DropdownList';
import InputCheck from 'components/controls/InputCheck';
import { Checkbox } from 'antd';


class PostConfigurationRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            row: {},
            loading: false,
        };
    }

    // let tempRow = props.data.filter((item) => item.Id == props.dataKey);
    // console.log("Row DFound: ", tempRow);


    componentDidMount() {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    this.setState({
                        ...this.state,
                        row: this.props.data,
                        loading: false,
                    });

                } catch (e) {
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onCheckedHandler = (event) => {
        console.log(event.target.name, ' == ', event.target.checked);
        console.log("row: ", this.state.row);
debugger
        this.props.onDataChange({ ...this.state.row, Value: Number(event.target.checked) });
    }

    onDropdownChange = async (event) => {
        // console.log(event.target.name, ' == ', event.target.value);        
        this.props.onDataChange({ ...this.state.row, RefId1: Number(event.target.value) });
    }

    onTextChange = (event) => {
        if (!_validator.isDigit(event.target.value))
            return;
debugger
        if (this.state.row.Type.includes("Age") && event.target.value.length > 2)
            return;
        else if (event.target.value.length > 5)
            return;

        this.props.onDataChange({ ...this.state.row, Value: event.target.value });
    }

    
    onTextStringChange = (event) => {
debugger    
        this.props.onDataChange({ ...this.state.row, ValueStr: event.target.value });
    }
    onTextChangeName = (event) => {
        this.props.onDataChange({ ...this.state.row, Name: event.target.value });
    }

    render() {
        if (this.props.valueType == 'CheckBox') {
            return (
                <div key={this.props.dataKey} className="row flex-sm-row">
                    <div key={this.props.dataKey} className="col-sm-3">
                        <DropdownList key={this.props.dataKey}
                            value={this.state.row.RefId1 ? this.state.row.RefId1 : 0}
                            name="PostId"
                            onChange={this.onDropdownChange}
                            placeholder="Select"
                            //heading={this.props.heading}
                            isDisabled={this.props.nameIsReadOnly}
                            className="w-100"
                            wrapClass="wrap"
                            isRequired={true}
                            options={this.props.dataList}
                        />
                    </div>

                    <div key={this.props.dataKey} className="col-sm-5">
                        <div className="col-sm-5 ">
                            <Checkbox
                                disabled={this.props.HideOther !== undefined ? (this.props.HideOther ? this.props.ItemName.includes('Other Qualificatio') : !this.props.ItemName.includes('Other Qualificatio')) : false}
                                name="isDegreeMandatory"
                                onChange={this.onCheckedHandler}
                                checked={this.props.IsCategoryMandatory === false && !this.props.ItemName.includes('N/A') ? this.props.IsCategoryMandatory : !!this.state.row.Value}>
                                    {this.props.heading == "ApplicableCategory" ? "Applicable" : "Mandatory" }</Checkbox>
                        </div>
                    </div>
                </div>
            );
        }
        else if (this.props.valueType == 'TextBox') {
            return (
                <div key={this.props.dataKey} className="row flex-sm-row">
                    <div key={this.props.dataKey} className="col-sm-3">
                        <DropdownList key={this.props.dataKey}
                            value={this.state.row.RefId1 ? this.state.row.RefId1 : 0}
                            name="PostId"
                            onChange={this.onDropdownChange}
                            placeholder="Select"
                            //heading={this.props.heading}
                            className="w-100"
                            wrapClass="wrap"
                            isDisabled={this.props.nameIsReadOnly}
                            isRequired={true}
                            options={this.props.dataList}
                        />
                    </div>

                    <div key={this.props.dataKey} className="col-sm-5">
                        <div className="col-sm-5">
                            <MyInput
                                type="text"
                                value={this.state.row.Value}
                                name="Other_Information"
                                onChange={this.onTextChange}
                             
                                //heading="Precent Grade"
                                //style={{ width: '60px' }}
                                // disabled={this.props.IsCategoryMandatory !== undefined ? (this.props.IsCategoryMandatory ? !this.props.ItemName.includes('N/A') : this.props.ItemName.includes('N/A')) : false}
                                disabled={this.props.IsCategoryMandatory || this.props.ItemName.includes('N/A') ? false : true}
                                wrapClass="wrap"
                                isRequired={true}
                            />
                        </div>
                    </div>
                </div>
            );
        }
        else if (this.props.valueType == 'TextBoxWithString') {
            return (
                <div key={this.props.dataKey} className="row flex-sm-row">
                    <div key={this.props.dataKey} className="col-sm-3">
                        <DropdownList key={this.props.dataKey}
                            value={this.state.row.RefId1 ? this.state.row.RefId1 : 0}
                            name="PostId"
                            onChange={this.onDropdownChange}
                            placeholder="Select"
                            //heading={this.props.heading}
                            className="w-100"
                            wrapClass="wrap"
                            isDisabled={this.props.nameIsReadOnly}
                            isRequired={true}
                            options={this.props.dataList}
                        />
                    </div>

                    <div key={this.props.dataKey} className="col-sm-5">
                        <div className="col-sm-5">
                            <MyInput
                                type="text"
                                value={this.state.row.ValueStr}
                                name="Other_Information"
                                onChange={this.onTextStringChange}
                             
                                //heading="Precent Grade"
                                //style={{ width: '60px' }}
                                // disabled={this.props.IsCategoryMandatory !== undefined ? (this.props.IsCategoryMandatory ? !this.props.ItemName.includes('N/A') : this.props.ItemName.includes('N/A')) : false}
                                disabled={this.props.IsCategoryMandatory || this.props.ItemName.includes('N/A') ? false : true}
                                wrapClass="wrap"
                                isRequired={true}
                            />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div key={this.props.dataKey} className="row flex-sm-row">
                    <div key={this.props.dataKey} className="col-sm-3">
                        <MyInput
                            type="text"
                            value={this.state.row.Name ? this.state.row.Name : ""}
                            name="Other_Information"
                            onChange={this.onTextChangeName}
                            disabled={this.props.nameIsReadOnly}
                            heading="Name"
                            style={{ backgroundColor: 'var(--color-neutral-bg)' }}
                            wrapClass="wrap"
                            isRequired={true}
                        />
                    </div>

                    <div key={this.props.dataKey} className="col-sm-5">
                        <div className="col-sm-5 ">
                            <MyInput
                                type="text"
                                value={this.state.row.Value}
                                name="Other_Information"
                                onChange={this.onTextChange}
                                heading="Age Relaxation"
                                //style={{ width: '60px' }}
                                wrapClass="wrap"
                                isRequired={true}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }
};

export default PostConfigurationRow;